import Layout from '@/layout';
import exchangeShop from './exchangeShop';
import { accountSecurityBeforeEnter } from '@/router/guards/accountSecurityGuard';

console.log('exchangeShop router----', exchangeShop);

export default [
  {
    path: '/income',
    name: 'Income',
    redirect: '/income/data',
    component: Layout,
    meta: {
      title: '收益管理',
      icon: 'icon-income',
    },
    children: [
      {
        path: 'data',
        name: 'IncomeData',
        component: () => import('@/views/income/Data'),
        meta: {
          title: '收益数据',
        },
      },
      {
        path: 'settlement',
        name: 'IncomeSettlement',
        component: () => import('@/views/income/Settlement'),
        meta: {
          title: '个人结算中心',
        },
      },
      {
        path: 'dataDetail',
        name: 'dataDetail',
        component: () => import('@/views/income/dataDetail'),
        meta: {
          title: '账单详情',
          activePath: 'data',
        },
        hidden: true,
      },
      {
        path: 'settlementDetail',
        name: 'settlementDetail',
        component: () => import('@/views/income/settlementDetail'),
        meta: {
          title: '提现记录',
          activePath: 'settlement',
        },
        hidden: true,
      },
      {
        path: 'settlementSet',
        name: 'settlementSet',
        component: () => import('@/views/income/settlementSet'),
        meta: {
          title: '结算设置',
          activePath: 'settlement',
        },
        beforeEnter: accountSecurityBeforeEnter,
        hidden: true,
        children: [
          {
            path: 'bindForm',
            name: 'bindForm',
            component: () =>
              import('@/views/income/components/resultSet/bindForm'),
            meta: {
              title: '绑定银行卡',
              activePath: 'settlement',
            },
            beforeEnter: accountSecurityBeforeEnter,
            hidden: true,
          },
          {
            path: 'bindInfo',
            name: 'bindInfo',
            component: () =>
              import('@/views/income/components/resultSet/bindInfo.vue'),
            meta: {
              title: '绑定信息',
              activePath: 'settlement',
            },
            hidden: true,
          },
        ],
      },
      exchangeShop[0].children[0],
    ],
  },
];
